/*
 * Market scoping for search.
 *
 * Products are tagged with a per-city Vendor ("Instant Offer Furniture Denver",
 * "Instant Offer Furniture Phoenix", ...). Market pages resolve their market from
 * the URL server-side (see snippets/market-vendor.liquid) and search is scoped
 * with the native Shopify vendor filter.
 *
 * The site root has no market, so this script locks search there until the customer
 * picks a location, then scopes the query to it.
 *
 * Deliberately STATELESS — nothing is stored in localStorage or cookies. The chosen
 * market lives only in the search URL (filter.p.vendor) and in the current page.
 * Land on the root again and you are asked again.
 *
 * Market data comes from the JSON blob rendered by snippets/market-picker.liquid,
 * which reads snippets/market-config.liquid. No market names are hardcoded here.
 */
(function () {
  if (window.__iofMarketScope) return;
  window.__iofMarketScope = true;

  var VENDOR_PARAM = 'filter.p.vendor';
  var FORM_SELECTOR = 'form.search__form, form.search-page__form';

  var config = null;

  function readConfig() {
    var node = document.querySelector('[data-market-config]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function knownVendor(vendor) {
    if (!vendor || !config) return false;
    return config.markets.some(function (m) {
      return m.vendor === vendor;
    });
  }

  function labelFor(vendor) {
    var match = config.markets.filter(function (m) {
      return m.vendor === vendor;
    })[0];
    return match ? match.label : '';
  }

  function eachForm(fn) {
    Array.prototype.forEach.call(document.querySelectorAll(FORM_SELECTOR), fn);
  }

  function searchInput(form) {
    return form.querySelector('input[type="search"]');
  }

  function setFormVendor(form, vendor) {
    var input = form.querySelector('input[name="' + VENDOR_PARAM + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = VENDOR_PARAM;
      form.appendChild(input);
    }
    input.value = vendor;
  }

  /* Results page reached without a market (direct link, old bookmark, Google). */
  function onSearchResults() {
    return (
      config &&
      config.searchUrl &&
      window.location.pathname.indexOf(config.searchUrl) === 0
    );
  }

  function currentUrlVendor() {
    return new URLSearchParams(window.location.search).get(VENDOR_PARAM) || '';
  }

  function redirectScoped(vendor) {
    var url = new URL(window.location.href);
    url.searchParams.set(VENDOR_PARAM, vendor);
    window.location.replace(url.toString());
  }

  var blockSubmit = function (event) {
    event.preventDefault();
    flashPickers();
  };

  var blockFocus = function (event) {
    if (event.target && event.target.blur) event.target.blur();
    flashPickers();
  };

  function flashPickers() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-market-picker]'),
      function (picker) {
        if (picker.hidden) return;
        picker.classList.remove('market-picker--flash');
        /* force reflow so the animation can restart */
        void picker.offsetWidth;
        picker.classList.add('market-picker--flash');
        var option = picker.querySelector('[data-market-choose]');
        if (option) option.focus();
      }
    );
  }

  /*
   * While no location is chosen the picker is the ONLY thing on screen: everything
   * alongside it is hidden — search input, recent searches, nav links, and (on an
   * unscoped results page) the results grid, which would otherwise show both cities.
   * Elements hidden this way are tagged so they can be restored on unlock.
   */
  var HIDDEN_FLAG = 'data-market-hidden';

  function hideAlongsidePickers() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-market-picker]'),
      function (picker) {
        var parent = picker.parentElement;
        if (!parent) return;
        Array.prototype.forEach.call(parent.children, function (sibling) {
          if (sibling === picker) return;
          if (sibling.tagName === 'SCRIPT' || sibling.tagName === 'STYLE') return;
          if (sibling.hidden) return;
          sibling.setAttribute(HIDDEN_FLAG, '');
          sibling.hidden = true;
        });
      }
    );
  }

  function restoreAlongsidePickers() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[' + HIDDEN_FLAG + ']'),
      function (el) {
        el.removeAttribute(HIDDEN_FLAG);
        el.hidden = false;
      }
    );
  }

  function lockSearch() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-market-picker]'),
      function (picker) {
        picker.hidden = false;
        picker.classList.add('market-picker--solo');
      }
    );
    hideAlongsidePickers();
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-market-scope-note]'),
      function (note) {
        note.hidden = true;
      }
    );
    /* Belt and braces: the input is hidden, but never let an unscoped query fire. */
    eachForm(function (form) {
      form.addEventListener('submit', blockSubmit);
      var input = searchInput(form);
      if (!input) return;
      input.readOnly = true;
      input.addEventListener('focus', blockFocus);
      input.addEventListener('click', flashPickers);
    });
  }

  function unlockSearch() {
    restoreAlongsidePickers();
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-market-picker]'),
      function (picker) {
        picker.classList.remove('market-picker--solo');
      }
    );
    eachForm(function (form) {
      form.removeEventListener('submit', blockSubmit);
      var input = searchInput(form);
      if (!input) return;
      input.readOnly = false;
      input.removeEventListener('focus', blockFocus);
      input.removeEventListener('click', flashPickers);
    });
  }

  /* showNote=false on market pages: the page itself already says where you are. */
  function applyScope(vendor, showNote) {
    unlockSearch();

    eachForm(function (form) {
      setFormVendor(form, vendor);
    });

    Array.prototype.forEach.call(
      document.querySelectorAll('predictive-search'),
      function (el) {
        el.setAttribute('data-market-vendor', vendor);
      }
    );

    Array.prototype.forEach.call(
      document.querySelectorAll('[data-market-picker]'),
      function (picker) {
        picker.hidden = true;
        picker.classList.remove('market-picker--flash');
      }
    );

    Array.prototype.forEach.call(
      document.querySelectorAll('[data-market-scope-note]'),
      function (note) {
        var label = note.querySelector('[data-market-scope-label]');
        if (label) label.textContent = labelFor(vendor);
        note.hidden = !showNote;
      }
    );
  }

  function choose(vendor) {
    if (!knownVendor(vendor)) return;

    /* On an unscoped results page the query has to be re-run server-side. */
    if (onSearchResults() && !currentUrlVendor()) {
      redirectScoped(vendor);
      return;
    }

    applyScope(vendor, true);

    var form = document.querySelector(FORM_SELECTOR);
    var input = form ? searchInput(form) : null;
    if (input) input.focus();
  }

  function bindPickers() {
    document.addEventListener('click', function (event) {
      var option = event.target.closest('[data-market-choose]');
      if (option) {
        event.preventDefault();
        choose(option.getAttribute('data-market-choose'));
        return;
      }
      if (event.target.closest('[data-market-change]')) {
        event.preventDefault();
        lockSearch();
        flashPickers();
      }
    });
  }

  function init() {
    config = readConfig();
    if (!config || !config.markets || !config.markets.length) return;

    bindPickers();

    /* Page already knows its market (market page, product page, scoped results). */
    if (knownVendor(config.serverVendor)) {
      applyScope(config.serverVendor, false);
      return;
    }

    /* No market on this page and nothing is remembered by design — ask. */
    lockSearch();
    if (onSearchResults()) flashPickers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
